import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MapPin, Phone, Mail, Award } from 'lucide-react';
import LmsButton from './LmsButton';
import { useAuth } from '../context/AuthContext';

const AUTH_ROUTES = ['/nmdf-direction-k7x2', '/nmdf-enseignant-m4p9', '/connexion', '/inscription'];

function Footer() {
  const { user } = useAuth();
  const location = useLocation();

  // Hide on login/signup pages and for roles that have their own dashboard nav.
  if (AUTH_ROUTES.some(r => location.pathname === r) || user?.role === 'admin' || user?.role === 'formateur') return null;

  return (
    <footer style={{ background: '#0f172a', color: '#94a3b8' }}>
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">

          {/* Colonne 1 — Marque */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src="/logo-sm.webp" alt="Nomedif" className="h-10 w-10 object-contain" />
              <div>
                <div className="text-white font-black text-lg leading-none">Nomedif</div>
                <div className="text-blue-400 text-xs font-semibold">Formations</div>
              </div>
            </div>
            <p className="text-sm leading-relaxed mb-5" style={{ color: '#64748b' }}>
              Former aujourd'hui les compétences de demain.
            </p>
            <div className="inline-flex items-center gap-2 px-3 py-2 rounded-xl text-xs font-semibold text-white" style={{ background: 'linear-gradient(90deg, #1d4ed8, #7c3aed)' }}>
              <Award size={14} /> Certifié Qualiopi
            </div>
          </div>

          {/* Colonne 2 — Navigation */}
          <div>
            <h4 className="text-white font-bold mb-5 text-sm uppercase tracking-wider">Navigation</h4>
            <ul className="space-y-3 text-sm">
              {[
                { to: '/', label: 'Accueil' },
                { to: '/catalogue', label: 'Catalogue' },
                { to: '/valeurs', label: 'Valeurs & Pédagogie' },
                { to: '/temoignages', label: 'Témoignages' },
                { to: '/blog', label: 'Blog & Actualités' },
                { to: '/apropos', label: 'À propos' },
              ].map(({ to, label }) => (
                <li key={to}>
                  <Link to={to} className="hover:text-white transition-colors">{label}</Link>
                </li>
              ))}
              <li>
                <LmsButton
                  className="hover:text-white transition-colors text-left cursor-pointer"
                  style={{ background: 'none', border: 'none', padding: 0, color: '#94a3b8', fontSize: 'inherit' }}
                >
                  Accès LMS
                </LmsButton>
              </li>
            </ul>
          </div>

          {/* Colonne 3 — Contact */}
          <div>
            <h4 className="text-white font-bold mb-5 text-sm uppercase tracking-wider">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2">
                <Phone size={14} color="#1d4ed8" />
                <span>06 05 70 30 40</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone size={14} color="#1d4ed8" />
                <span>07 45 98 77 03</span>
              </li>
              <li className="flex items-center gap-2">
                <Mail size={14} color="#1d4ed8" />
                <span>contact@nomedif.fr</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={14} color="#1d4ed8" className="mt-0.5 flex-shrink-0" />
                <span>Île-de-France · Rhône-Alpes · PACA</span>
              </li>
            </ul>
          </div>

          {/* Colonne 4 — Infos */}
          <div>
            <h4 className="text-white font-bold mb-5 text-sm uppercase tracking-wider">Informations</h4>
            <ul className="space-y-3 text-sm">
              {[
                { to: '/qualiopi', label: 'Certification Qualiopi' },
                { to: '/faq', label: 'FAQ' },
                { to: '/mentions-legales', label: 'Mentions légales' },
                { to: '/cgv', label: 'CGV' },
                { to: '/confidentialite', label: 'Confidentialité' },
                { to: '/auditeur', label: 'Accès auditeur' },
              ].map(({ to, label }) => (
                <li key={to}>
                  <Link to={to} className="hover:text-white transition-colors">{label}</Link>
                </li>
              ))}
            </ul>
            <Link
              to="/contact"
              className="mt-5 inline-block text-white px-5 py-2.5 rounded-xl text-sm font-bold hover:opacity-90 transition-all"
              style={{ background: 'linear-gradient(90deg, #1d4ed8, #2563eb)' }}
            >
              Nous contacter
            </Link>
          </div>

        </div>
      </div>

      <div
        className="py-4 text-center text-xs"
        style={{ borderTop: '1px solid rgba(255,255,255,0.06)', color: '#475569' }}
      >
        © {new Date().getFullYear()} Nomedif Formations. Tous droits réservés. — Organisme certifié Qualiopi
      </div>
    </footer>
  );
}

export default Footer;
